import { useLiveData, useService } from '@toeverything/infra';
import * as styles from './add-on.css';
import { useI18n } from '@affine/i18n';
import { SubscriptionService } from '@affine/core/modules/cloud';
import { useMemo } from 'react';
import { GlobalDialogService } from '@affine/core/modules/dialogs';
import { UserCreditsDetailsService } from '@affine/core/modules/cloud/services/user-credits-detail';
const AddOn = () => {
  const t = useI18n();
  const subscriptionService = useService(SubscriptionService);
  const globalDialogService = useService(GlobalDialogService);
  const userCreditsDetailService = useService(UserCreditsDetailsService);
  const currentPlan = useLiveData(
    subscriptionService.subscription.currentPlan$
  );
  const credits = useLiveData(userCreditsDetailService.creditsDetail.credits$);
  const addonPrices = useLiveData(subscriptionService.prices.addonPrice$);

  const present = useMemo(() => {
    let maxPresent = 0;
    addonPrices?.forEach(price => {
      const currentPresent = (price.giftQuantity / price.quantity) * 100;
      if (currentPresent > maxPresent) {
        maxPresent = currentPresent;
      }
    });
    return maxPresent;
  }, [addonPrices]);

  return currentPlan !== 'Free' ? (
    <div className={styles.addonCard}>
      <div className={styles.addonLeft}>
        <div className={styles.addonLeftTitle}>
          <div className={styles.addonLeftTitleText}>
            {t['com.muset.payment.add-on.title']()}
          </div>
          {present !== 0 && (
            <div className={styles.addonLeftTitleTag}>
              <span className={styles.addonLeftTitleTagText}>
                {present === 100
                  ? t['com.muset.payment.add-on.tag.100%']()
                  : t['com.muset.payment.add-on.tag.other']({
                      present: `${present}%`,
                    })}
              </span>
            </div>
          )}
        </div>
        <div className={styles.addonLeftDescription}>
          {t['com.muset.payment.add-on.description']()}
        </div>
      </div>
      <div
        className={styles.addonRight}
        onClick={() => {
          globalDialogService.open('add-on', {
            prices: addonPrices,
            remaindCredits: credits.effective.toString(),
          });
        }}
      >
        {t['com.muset.payment.add-on.button']()}
      </div>
    </div>
  ) : null;
};

export default AddOn;
